"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pako_1 = __importDefault(require("pako"));
var FALLBACK_ZL_SERVICE = "stage";
var getServiceUrl = function (zlservice) {
    return "https://shortcode-" + zlservice + ".brp.zlthunder.net";
};
exports.save = function (userId, prcodes, api, state, zlservice) { return __awaiter(void 0, void 0, void 0, function () {
    var blob, blobsize;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                blob = {
                    api: api,
                    state: btoa(pako_1.default.deflate(JSON.stringify(state), { to: 'string' }))
                };
                blobsize = JSON.stringify(blob).length;
                if (blobsize > 4096) {
                    throw "State information too long, " + blobsize + " > 4096";
                }
                console.log("blobsize:", blobsize);
                return [4 /*yield*/, fetch(getServiceUrl(zlservice) + "/code", {
                        method: "POST",
                        headers: {
                            'accept': 'application/json',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            clientApplication: "BRP API",
                            sessionId: userId,
                            productionCodes: prcodes,
                            blob: blob
                        })
                    }).then(function (response) {
                        if (response.ok) {
                            return response.json();
                        }
                        console.error(response.url + " : " + response.statusText);
                        throw response.statusText;
                    }).then(function (json) {
                        return json.shortCode;
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.load = function (shortcode, zlservice) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(getServiceUrl(zlservice) + "/code/" + shortcode, {
                    method: "GET",
                    headers: {
                        'accept': 'application/json'
                    },
                }).then(function (response) {
                    return response.json();
                }).then(function (json) { return __awaiter(void 0, void 0, void 0, function () {
                    var state;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!json.blob && zlservice !== FALLBACK_ZL_SERVICE && json.errorMessage === "Short code does not exist")) return [3 /*break*/, 2];
                                return [4 /*yield*/, exports.load(shortcode, FALLBACK_ZL_SERVICE)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2:
                                if (undefined === json.blob)
                                    return [2 /*return*/, { api: -1, state: { error: "'blob' not found in 'json'\n\t" + Object.keys(json) + "\n\t" + json } }];
                                state = JSON.parse(pako_1.default.inflate(atob(json.blob.state), { to: 'string' }));
                                console.log("Shortcode loaded: " + shortcode, state);
                                return [2 /*return*/, { api: json.blob.api, state: state }];
                        }
                    });
                }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//# sourceMappingURL=shortcode.js.map